export default __webpack_public_path__ + "static/media/lotusoverdose.fcbc6300.png";